import {
  CaretRightOutlined,
  RightOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  LikeOutlined 
} from "@ant-design/icons";
import {
  Collapse,
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Alert,
  notification,
  Table,
  Divider,
  Badge, Card, Statistic
} from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { useParams } from 'react-router-dom';
import {
  DATE_FORMAT_DMY_SLASH,
  SAVE_SUCCESS_MSG,
  SUCCESS_STATUS,
} from "../../utility/Constants";


import moment from "moment";
import commonUtility from "../../utility/Utils";
import accountService from "../../api/account.service";
import memberService from "../../api/member.service";
import ProgrammeService from "../../api/programme.service";
import paymentService from "../../api/payment.service";
import PaymentModeDetails from "./PaymentModeDetails";
import TestDetailComp from "./TestDetailComp";



const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;



const defaultFormValues = {
  mode: "ADD",
  payment_id: 0,
  voucher_id:0,
  member_id: 0,
  enrollment_id: 0,
  payment_date: "",
  cr_ac_id: 0,
  payable_amount: 0,
  payment_amount: 0,
  short_excess_amount: 0,
  short_excess_cr_ac_id: "",
  receipt_data: [],
  payment_data: []
};



const columns = [
  {
    title: 'Receipt No',
    key: 'receipt_no',
    dataIndex: 'receipt_no'
  },
  {
    title: 'Receipt Date',
    key: 'receipt_date',
    dataIndex: 'receipt_date'
  },
  {
    title: 'Net Payable Amount',
    key: 'net_payble_amount',
    dataIndex: 'net_payble_amount'
  },
];




const PaymentEntry = () => {
  const [paymentForm] = Form.useForm();

  const params = useParams();


  //   const [enrollmentID,setEnrollmentID] = useState(0);
  //   const [receiptID,setReceiptID] = useState(0);


  const [programmeList, setProgrammeList] = useState([]);
  //const [programmeGroupList, setProgrammeGroupList] = useState([]);

  const [memberList, setMemberList] = useState([]);

  const [paymentModeList, setPaymentModeList] = useState([]);

  const [accountList, setAccountList] = useState([]);
  const [receiptList, setReceiptList] = useState([]);
  const [paymentDetailList, setPaymentDetailList] = useState([]);
  const [formDetailStateX, setFormDetailStateX] = useState([]);
  const [itemObject, setItemObject] = useState({});

  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const [totalPaidAmount, setTotalPaidAmount] = useState(0);
  const [shortExcessAmount, setShortExcessAmount] = useState(0);

  const [paymentID, setPaymentID] = useState(0);
  const [isDisableForEditMode, setIsDisableForEditMode] = useState(false);
  const [saveButtonDisable, setSaveButtonDisable] = useState(true);

  const [memberID, setMemberID] = useState(0);
  const [programmeID, setProgrammeID] = useState(0);
  const [shortExcessMemberAmount, setShortExcessMemberAmount] = useState(0);
  
  


  const onPaymentSave = async (values) => {
    const data = { formdata: values };
    console.log("save data",values);



    paymentService.programmeReceiptPaymentSave(data).then((res)=>{
      console.log("Res data",res);

      if (res.data.response_status === SUCCESS_STATUS) {
        commonUtility.openNotification("bottom","Suceess",res.data.response_msg)
      }
      else{
        commonUtility.openNotification("bottom","Failed",res.data.response_msg)
      }

    });

    


  };



  const getMemberByProgramme = () => {
    setMemberList([])
    const programme_id = paymentForm.getFieldValue("programme_id");
    const data = { formdata: { programme_id: programme_id } };
    memberService.memberListByProgramme(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        const response = res.data.response_data;
        setMemberList(response)
      }
    });
  }

  const getReceiptData = (value, event) => {
    
    const programme_id = paymentForm.getFieldValue("programme_id");
    const member_id = paymentForm.getFieldValue("member_id");
    const enrollment_id =  event.enrollment_id;

    paymentForm.setFieldsValue({
      enrollment_id:enrollment_id
    });

    const data = { formdata: { member_id: member_id, programme_id: programme_id }};
    paymentService.unpaidReceiptAgainstMember(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        const response = res.data.response_data;
        setReceiptList(response)
        getMemberExcessAmount();
      }
    });



  };



  const calulateShortExcessAmount = (i,type) => {
    
    const totalPayable = paymentForm.getFieldValue("payable_amount") > 0  ? parseFloat(paymentForm.getFieldValue("payable_amount")) : 0;
    setTotalPaidAmount(0);
    
    const payment_method_datas = paymentForm.getFieldValue('payment_data');
    let total_payment_methods_amount = payment_method_datas.reduce( (prev, next) => parseFloat(prev)  + parseFloat(commonUtility.sanitizeValue(next.amount))    , 0);

    setTotalPaidAmount(total_payment_methods_amount)

    if(type=="ADD"){
      paymentForm.setFieldsValue({
        payment_amount:total_payment_methods_amount,
        short_excess_amount: parseFloat(totalPayable)-parseFloat(total_payment_methods_amount)
      });
  }
    else {
      const row_amount = paymentForm.getFieldValue(["payment_data",i,"amount",])
     // console.log("row_amount",row_amount)
      total_payment_methods_amount = parseFloat(total_payment_methods_amount)-parseFloat(row_amount)
      paymentForm.setFieldsValue({
        payment_amount:total_payment_methods_amount,
        short_excess_amount: parseFloat(totalPayable)-parseFloat(total_payment_methods_amount)
      });
    }
    
    setTotalPaidAmount(total_payment_methods_amount)

    if(totalPayable > 0 && total_payment_methods_amount > 0) {
      setSaveButtonDisable(false)
    }
    else{
      setSaveButtonDisable(true)
    }


    //paymentForm.setFields({readonly:true})
  };



  useEffect(() => {
    accountService.accountList().then((res) => {
      setAccountList(res.data.response_data);
    });
  }, []);


  const onPaymentDateSelect = (date, dateString) => {
    console.log(date, dateString);
    paymentForm.setFieldsValue({
      payment_date: dateString,
    });
  };


  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    
   
    
    setSelectedRowKeys(newSelectedRowKeys);
    paymentForm.setFieldsValue({
      receipt_data:newSelectedRowKeys
    });

    const z = receiptList.filter(i => newSelectedRowKeys.includes(i.receipt_id));
    const total = z.reduce((prev, next) => prev + next.net_payble_amount, 0);
    const memberBalance = paymentForm.getFieldValue("member_balance") > 0  ? parseFloat(paymentForm.getFieldValue("member_balance")) : 0;

    setTotalPayableAmount(total+memberBalance);
    
    paymentForm.setFieldsValue({
      payable_amount:parseFloat(total) + parseFloat(memberBalance),
      short_excess_amount:parseFloat(total)-parseFloat(totalPaidAmount)
    })
    setShortExcessAmount(total-totalPaidAmount)

  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_NONE,


    ],
  };



  useEffect(() => {
    ProgrammeService.programmeList().then((res) => {
      console.log(res);
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgrammeList(res.data.response_data);
      }

    });
  }, []);



  useEffect(() => {
    accountService.paymentModeList().then((res) => {
      console.log(res.data.response_data);
      setPaymentModeList(res.data.response_data);
    });
  }, [])





  const getMemberExcessAmount = () =>{
    console.log("member_id",paymentForm.getFieldValue('member_id'));
    console.log("enrollment_id",paymentForm.getFieldValue('enrollment_id'));

    const data = {
      formdata: {
        member_id: paymentForm.getFieldValue('member_id'),
        enrollment_id: paymentForm.getFieldValue('enrollment_id'),
      },
    };

    paymentService.shortExcessAmount(data).then((res) => {
      const short_excess_data = res.data.response_data[0];
      setShortExcessMemberAmount(short_excess_data.short_excess)
      paymentForm.setFieldsValue({
        member_balance : short_excess_data.short_excess
      })
    });
  }

  /**
   * Edit Mode
   */

   useEffect(()=>{
    console.log("useeffect params",params);
    setPaymentID(params.paymentid);
  },[])


  useEffect(()=> {
    if(paymentID > 0){
        const data = {
            formdata: {
              payment_id: paymentID,
            },
          };
        paymentService.paymentmasterDataByID(data).then((res)=>{
            if (res.data.response_status === SUCCESS_STATUS) {
                const payment_data = res.data.response_data[0];
               // console.warn(enrollment_data);

              paymentForm.setFieldsValue({
                mode: "EDIT",
                payment_id: payment_data.payment_id,
                voucher_id:payment_data.voucher_id,
                member_id: payment_data.member_id,
                programme_id: payment_data.programme_id,
                enrollment_id:  payment_data.enrollment_id,
                payment_date: payment_data.payment_date,
                date_of_payment: payment_data.payment_date ?  moment(payment_data.payment_date,DATE_FORMAT_DMY_SLASH) : '',
                cr_ac_id: payment_data.cr_ac_id,
                payable_amount: payment_data.total_payble_amount,
                payment_amount: payment_data.payment_amount,
                short_excess_amount: payment_data.short_excess_amount,
                short_excess_cr_ac_id: payment_data.short_excess_cr_ac_id,
                member_balance : payment_data.short_excess_amount
              })

              // paymentForm.setFieldsValue({
              //   member_balance : short_excess_data.short_excess
              // })
              getMemberByProgramme();
              setIsDisableForEditMode(true);
              setTotalPayableAmount(payment_data.total_payble_amount)
              setMemberID(payment_data.member_id);
              setProgrammeID(payment_data.programme_id)
            }
        });




       


        paymentService.paymentDetailsDataByID(data).then((res)=> {
          if(res.data.response_status === SUCCESS_STATUS) {
            console.log(res) 
            setPaymentDetailList(res.data.response_data)  
          }
        });




    }
  },[paymentID]);

  useEffect(()=>{
    const unpaidpaidParams = {
      formdata: {
        payment_id: paymentID,
        member_id:memberID,
        programme_id:programmeID,
      },
    };
    paymentService.paymentPaidUnpaidReceiptList(unpaidpaidParams).then((res)=> {
      setReceiptList([])
      if(res.data.response_status === SUCCESS_STATUS) {
          const paidList  = res.data.response_data;
          setReceiptList(res.data.response_data)
          let obj=[]
          paidList.map((paid_list)=>{
            if(paid_list.receipt_id>0 && paid_list.is_payment_done == "Y"){
              obj.push(paid_list.receipt_id) 
            }
          })
          setSelectedRowKeys(obj)
          paymentForm.setFieldsValue({
            receipt_data:obj
          });
      }
    });

  },[memberID,programmeID])



  return (
    <div className="form-input-style">
      <Row
        className="login-first-step-row"
        style={{ background: "transparent" }}
      >
        <Col className="login-first-step-block-1" xs={24} xl={24}>
          <Form
            form={paymentForm}
            layout="vertical"
            onFinish={onPaymentSave}
            autoComplete="off"
            //initialValues={defaultValues}
            initialValues={defaultFormValues}
          >
            <Collapse
              bordered={false}
              defaultActiveKey={[
                "programme_receipt_payment",
              ]}

              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
            >
              <Panel
                header={
                  <>
                    <h4>Programme wise receipt payment</h4>
                  </>
                }
                key="programme_receipt_payment"
              >
                <Row gutter={20}>



                  <Col xs={24} xl={6}>
                    <Form.Item name="programme_id" label="Programme" rules={[
                      {
                        required: true,
                        message: 'Programme is required',
                      },
                    ]}>
                      <Select className="text-left"
                        onSelect={() =>
                          getMemberByProgramme()
                        }
                        disabled={isDisableForEditMode} 
                      >

                        {
                          programmeList.length > 0 ?
                            programmeList.map(programme_data => (
                              <Option key={programme_data.programme_id} value={programme_data.programme_id}>{programme_data.programme_name}</Option>

                            ))
                            : ''
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col className="gutter-row" xs={24} xl={6}>
                    <Form.Item
                      name="member_id"
                      label="Search (Name | Mobile no | Father Name)"
                    >
                      <Select
                        showSearch
                        placeholder="Search to Select"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.includes(input)
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        onSelect={(value, event) =>
                          getReceiptData(value, event)
                        }
                        disabled={isDisableForEditMode}
                      >
                        {memberList.length > 0
                          ? memberList.map((member_list) => (
                            <Option
                              key={member_list.member_id}
                              value={member_list.member_id}
                              enrollment_id={member_list.enrollment_id}
                            >
                              {`${member_list.member_fname} ${member_list.member_lname
                                } | ${member_list.primary_mobile}  ${member_list.father_name != null
                                  ? member_list.father_name
                                  : ""
                                }`}
                            </Option>
                          ))
                          : ""}
                      </Select>
                    </Form.Item>

                  </Col>


                  <Col xs={24} xl={4}>
                    <Form.Item name="date_of_payment" label="Payment Date">
                      <DatePicker
                        format={DATE_FORMAT_DMY_SLASH}
                        style={{ width: "100%" }}
                        inputReadOnly={true}
                        onChange={onPaymentDateSelect}
                        
                      />
                    </Form.Item>
                    <Form.Item name="payment_date" hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={4}>
                    <Form.Item
                      name="cr_ac_id"
                      label="Account to be credited"
                      rules={[
                        {
                          required: true,
                          message: "Credit account is required",
                        },
                      ]}
                    >
                      <Select className="text-left">
                        {accountList.length > 0
                          ? accountList.map((account_list) => (
                            <Option
                              key={account_list.id}
                              value={account_list.id}
                            >
                              {account_list.account_name}
                            </Option>
                          ))
                          : ""}
                      </Select>
                    </Form.Item>
                  </Col>



                  <Col xs={24} xl={4}>
                 
                    <Form.Item name="member_balance" label="Member Balance" >
                      <Input type="text" readOnly={true} />
                    </Form.Item>
                  </Col>


                

                </Row>

                {
                  receiptList && receiptList.length > 0 ? (<>
                    <Row gutter={20}>
                      <Col xs={24} xl={24}>

                        <Table rowKey='receipt_id' rowSelection={rowSelection} columns={columns} dataSource={receiptList} pagination={false} />
                      </Col>
                    </Row>
                  </>) : ''
                }





                {/* <Badge.Ribbon text={<>Total Amount Rs. {totalPayableAmount} </>} color="magenta">
                  <Card title="" size="small">
                  

                    <Row gutter={16}>
                      <Col span={8}>
                        <Statistic title="Payable" value={1128} prefix={<>&#8377;</>} />
                      </Col>
                      <Col span={8}>
                        <Statistic title="Receipt Amount" value={totalPayableAmount} prefix={<>&#8377;</>} />
                      </Col>
                      <Col span={8}>
                        <Statistic title="Amount" value={93} prefix={<>&#8377;</>} />
                      </Col>
                    </Row>

                  </Card>
                </Badge.Ribbon> */}


                {/* <Card title="" size="small">
                  

                    <Row gutter={16}>
                      <Col span={8}>
                        <Statistic title="Payable" value={1128} prefix={<>&#8377;</>} />
                      </Col>
                      <Col span={8}>
                        <Statistic title="Receipt Amount" value={totalPayableAmount} prefix={<>&#8377;</>} />
                      </Col>
                      <Col span={8}>
                        <Statistic title="Amount" value={93} prefix={<>&#8377;</>} />
                      </Col>
                    </Row>

                  </Card> */}

                <div style={{ marginTop: '2rem' }}></div>

                <PaymentModeDetails paymentForm={paymentForm} totalPayableAmount={totalPayableAmount}  calulateShortExcessAmount={calulateShortExcessAmount} paymentDetailList={paymentDetailList} />




                <Row gutter={20}>
                  <Col xs={24} xl={6}>
                    <Form.Item name="short_excess_amount" label="Short/Excess">
                      <Input type="text" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} xl={6}>
                    <Form.Item name="short_excess_cr_ac_id" label="Account">
                   
                      <Select className="text-left">
                        {accountList.length > 0
                          ? accountList.map((account_list) => (
                            <Option
                              key={account_list.id}
                              value={account_list.id}
                            >
                              {account_list.account_name}
                            </Option>
                          ))
                          : ""}
                      </Select>
                  
                    </Form.Item>

                    {/* <Form.Item name="payable_amount" label="Payable Amount" hidden={false} >
                      <Input type="text" />
                    </Form.Item>

                    <Form.Item name="payment_amount" label="Payment Amount" hidden={false} >
                      <Input type="text" />
                    </Form.Item> */}

                    <Form.Item name="mode" label="Mode" hidden={true} >
                      <Input type="text" />
                    </Form.Item>

                    <Form.Item name="payment_id"  hidden={true} >
                      <Input type="text" />
                    </Form.Item>

                    <Form.Item name="voucher_id"  hidden={true} >
                      <Input type="text" />
                    </Form.Item>

                    <Form.Item name="enrollment_id"  hidden={true} >
                      <Input type="text" />
                    </Form.Item>

                    <Form.Item name="receipt_data"  hidden={true} >
                      <Input type="text" />
                    </Form.Item>
                    
                  </Col>
                </Row>


                 
                <Card title="" size="small" style={{marginBottom:"1rem"}}>
                  

                  <Row gutter={16}>
                    <Col span={12}>
                      <Statistic title="Payable" value={totalPayableAmount} prefix={<>&#8377;</>} />
                    </Col>
                    {/* <Col span={8}>
                      <Statistic title="Receipt Amount" value={totalPayableAmount} prefix={<>&#8377;</>} />
                    </Col> */}
                    <Col span={12}>
                      <Statistic title="Amount" value={totalPaidAmount} prefix={<>&#8377;</>} />
                    </Col>
                  </Row>

                </Card>



                <Row justify="end">
                  <Col>
                    <Form.Item>
                      <Button
                        htmlType="submit"
                        shape="round"
                       className="custom-button-green"
                       disabled={saveButtonDisable}
                      >
                        Save <RightOutlined />
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>







                {/* <TestDetailComp paymentForm={paymentForm}/> */}

              </Panel>



            </Collapse>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default PaymentEntry;
